import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { AppCommonModule } from "@common/common.module";

import { CallBackMobileComponent } from "./call-back-mobile/call-back-mobile.component";
import { LocateUsMobileComponent } from "./locate-us-mobile/locate-us-mobile.component";
import { WriteUsMobileComponent } from "./write-us-mobile/write-us-mobile.component";

import { LocateUsComponent } from "./locate-us/locate-us.component";
import { WriteUsComponent } from "./write-us/write-us.component";
import { CallBackComponent } from "./call-back/call-back.component";

@NgModule({
  declarations: [
    WriteUsComponent,
    CallBackComponent,
    LocateUsComponent,
    CallBackMobileComponent,
    LocateUsMobileComponent,
    WriteUsMobileComponent,
  ],
  imports: [AppCommonModule],
  entryComponents: [WriteUsComponent, CallBackComponent, LocateUsComponent],
  exports: [
    WriteUsComponent,
    CallBackComponent,
    LocateUsComponent,
    CallBackMobileComponent,
    LocateUsMobileComponent,
    WriteUsMobileComponent,
  ],
})
export class PopUpsModule {}
